<template>
  <div>
    <label class="checkbox">
      <input id="checkbox" v-model="checked" type="checkbox" @change="$emit('input')" />
      <span></span>
    </label>
    <label class="checkbox-text" for="checkbox">
      <span><slot></slot></span>
    </label>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: false
    };
  }
};
</script>

<style lang="scss" scoped>
label.checkbox {
  cursor: pointer;
  position: relative;
  span {
    width: 14px;
    height: 14px;
    border: 1px solid $gray;
    border-radius: 4px;
    display: inline-block;
    transition: all linear 0.3s;
    &:after {
      content: '';
      position: absolute;
      top: 4px;
      left: 6px;
      border-bottom: 2px solid white;
      border-right: 2px solid white;
      height: 9px;
      width: 4px;
      transform: rotate(45deg);
      visibility: hidden;
    }
  }
  input {
    display: none;
    &:checked ~ span {
      border: 1px solid var(--exp-color);
      background: var(--exp-color);
      &:after {
        visibility: visible;
      }
    }
  }
}
.checkbox-text {
  cursor: pointer;
  color: #545454;
  height: 24px;
}
</style>
